import { useEffect } from "react";

const PLAUSIBLE_INIT_SNIPPET = `window.plausible=window.plausible||function(){(plausible.q=plausible.q||[]).push(arguments)},plausible.init=plausible.init||function(i){plausible.o=i||{}};
plausible.init()`;

/**
 * Plausible:
 * - Новий варіант з кабінету: `VITE_PLAUSIBLE_SCRIPT_SRC` = повний URL до `pa-….js` + інʼєкція `plausible.init()`.
 * - Класичний: `VITE_PLAUSIBLE_DOMAIN` + `script.js` і `data-domain`.
 */
export function PlausibleAnalytics() {
  useEffect(() => {
    if (typeof document === "undefined") return;

    const scriptSrc = import.meta.env.VITE_PLAUSIBLE_SCRIPT_SRC?.trim();
    const domain = import.meta.env.VITE_PLAUSIBLE_DOMAIN?.trim();

    if (scriptSrc) {
      const loaderId = "plausible-pa-loader";
      if (document.getElementById(loaderId)) return;
      const s = document.createElement("script");
      s.id = loaderId;
      s.async = true;
      s.src = scriptSrc;
      s.onload = () => {
        const initId = "plausible-pa-init";
        if (document.getElementById(initId)) return;
        const inline = document.createElement("script");
        inline.id = initId;
        inline.textContent = PLAUSIBLE_INIT_SNIPPET;
        document.head.appendChild(inline);
      };
      document.head.appendChild(s);
      return;
    }

    if (!domain) return;

    const id = "plausible-analytics";
    if (document.getElementById(id)) return;
    const s = document.createElement("script");
    s.id = id;
    s.defer = true;
    s.setAttribute("data-domain", domain);
    s.src = "https://plausible.io/js/script.js";
    document.head.appendChild(s);
  }, []);
  return null;
}
